import { createWorkerAction } from '../../lib';

export const resizeComponent = createWorkerAction('RESIZE_COMPONENT');
